/**
 * MINIPALM PREVIEW - Canvas-basierte Live-Vorschau
 * Zeigt personalisierte MiniPalm-Produkte mit Echtzeit-Rendering
 */

const MiniPalmPreview = {
  // ========================================
  // KONFIGURATION (ANPASSBAR!)
  // ========================================
  config: {
    // Base-Produktbilder (nach Topffarbe)
    baseImages: {
      'Türkis': 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/vorschaubild_tuerkis.png?v=1763977275',
      'Rosa': 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/vorschaubild_rosa.png?v=1763977291',
      'Weiß': 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/vorschau_weiss.png?v=1780379727',
      'Braun': 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/vorschau_braun.png?v=1780379727'
    },

    // Canvas-Dimensionen
    canvasWidth: 800,
    canvasHeight: 800,

    // Motiv-URLs (1-27) - verdickte Versionen (nur mini-palm, bessere Sichtbarkeit)
    motivUrls: {
      1: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_1.png?v=1780382370',
      2: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_2.png?v=1780382416',
      3: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_3.png?v=1780382418',
      4: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_4.png?v=1780382422',
      5: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_5.png?v=1780382425',
      6: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_6.png?v=1780382428',
      7: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_7.png?v=1780382431',
      8: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_8.png?v=1780382435',
      9: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_9.png?v=1780382438',
      10: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_10.png?v=1780382441',
      11: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_11.png?v=1780382444',
      12: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_12.png?v=1780382448',
      13: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_13.png?v=1780382451',
      14: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_14.png?v=1780382454',
      15: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_15.png?v=1780382458',
      16: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_16.png?v=1780382461',
      17: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_17.png?v=1780382467',
      18: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_18.png?v=1780382470',
      19: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_19.png?v=1780382473',
      20: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_20.png?v=1780382477',
      21: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_21.png?v=1780382480',
      22: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_22.png?v=1780382483',
      23: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_23.png?v=1780382486',
      24: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_24.png?v=1780382489',
      25: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_25.png?v=1780382493',
      26: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_26.png?v=1780382496',
      27: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/minipalm_motiv_bold_27.png?v=1780382499'
    },

    // Text-Positionen und Styles
    textConfig: {
      name: {
        x: 408,           // Leicht nach rechts
        y: 520,           // Über dem Motiv
        fontSize: 42,     // Etwas kleiner
        fontFamily: 'Halimun',
        color: '#4a4a4a', // Dunkelgrau
        align: 'center',
        baseline: 'middle'
      }
    },

    // Motiv-Position und Größe
    motivConfig: {
      x: 415,             // Leicht nach rechts
      y: 645,             // Weit unten
      maxWidth: 160,      // Max. Breite
      maxHeight: 160      // Max. Höhe
    }
  },

  // Interner State
  canvas: null,
  ctx: null,
  images: {
    baseTuerkis: null,
    baseRosa: null,
    motiv: null
  },
  fontsLoaded: false,
  isRendering: false,

  /**
   * Initialisierung
   */
  init() {
    // Canvas-Element finden
    this.canvas = document.getElementById('minipalm-preview-canvas');
    if (!this.canvas) {
      console.error('MiniPalm: Canvas element not found');
      return;
    }

    this.ctx = this.canvas.getContext('2d');

    // Event Listeners registrieren
    this.setupEventListeners();

    // Fonts vorladen
    this.loadFonts();

    // Base Image vorladen
    this.loadBaseImage();

    // Warenkorb-Integration einrichten
    this.setupCartIntegration();

    console.log('MiniPalmPreview initialized');
  },

  /**
   * Event Listeners einrichten
   */
  setupEventListeners() {
    // Vorschau-Button
    const previewBtn = document.getElementById('minipalm-preview-btn');
    if (previewBtn) {
      previewBtn.addEventListener('click', () => this.openPreview());
    }

    // Modal schließen
    const closeBtn = document.querySelector('.minipalm-preview-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closePreview());
    }

    // Modal-Hintergrund klicken
    const modal = document.getElementById('minipalm-preview-modal');
    if (modal) {
      modal.addEventListener('click', (e) => {
        if (e.target.id === 'minipalm-preview-modal') {
          this.closePreview();
        }
      });
    }

    // ESC-Taste zum Schließen
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closePreview();
      }
    });
  },

  /**
   * Fonts laden und auf Bereitschaft warten
   */
  async loadFonts() {
    try {
      // Warten bis Fonts geladen sind
      await document.fonts.ready;

      // Font explizit laden
      await document.fonts.load('48px Halimun');

      this.fontsLoaded = true;
      console.log('MiniPalm: ✓ Font loaded successfully');
    } catch (error) {
      console.error('MiniPalm: Error loading font:', error);
      this.fontsLoaded = true; // Trotzdem weitermachen
    }
  },

  /**
   * Base-Produktbilder vorladen
   */
  loadBaseImage() {
    // Türkis-Bild laden
    this.images.baseTuerkis = new Image();
    this.images.baseTuerkis.crossOrigin = 'anonymous';
    this.images.baseTuerkis.onload = () => {
      console.log('MiniPalm: ✓ Türkis base image loaded');
    };
    this.images.baseTuerkis.onerror = () => {
      console.error('MiniPalm: ✗ Failed to load türkis base image');
    };
    this.images.baseTuerkis.src = this.config.baseImages['Türkis'];

    // Rosa-Bild laden
    this.images.baseRosa = new Image();
    this.images.baseRosa.crossOrigin = 'anonymous';
    this.images.baseRosa.onload = () => {
      console.log('MiniPalm: ✓ Rosa base image loaded');
    };
    this.images.baseRosa.onerror = () => {
      console.error('MiniPalm: ✗ Failed to load rosa base image');
    };
    this.images.baseRosa.src = this.config.baseImages['Rosa'];
  },

  /**
   * Motiv-Bild laden
   */
  loadMotiv(motivNumber) {
    return new Promise((resolve, reject) => {
      if (!motivNumber) {
        this.images.motiv = null;
        resolve();
        return;
      }

      const motivUrl = this.config.motivUrls[motivNumber];

      if (!motivUrl) {
        console.error(`MiniPalm: Motiv ${motivNumber} not found`);
        this.images.motiv = null;
        resolve();
        return;
      }

      this.images.motiv = new Image();
      this.images.motiv.crossOrigin = 'anonymous';

      this.images.motiv.onload = () => {
        console.log(`MiniPalm: ✓ Motiv ${motivNumber} loaded`);
        resolve();
      };

      this.images.motiv.onerror = () => {
        console.error(`MiniPalm: ✗ Failed to load motiv ${motivNumber}`);
        this.images.motiv = null;
        resolve(); // Trotzdem weitermachen
      };

      this.images.motiv.src = motivUrl;
    });
  },

  /**
   * Vorschau-Modal öffnen
   */
  async openPreview() {
    if (this.isRendering) return;

    // Validierung
    const formData = this.getFormData();
    if (!formData.name || !formData.motiv) {
      alert('Bitte fülle alle Pflichtfelder aus (Name und Motiv).');
      return;
    }

    // Felder mit Warenkorb synchronisieren
    this.syncFieldsToCart();

    const modal = document.getElementById('minipalm-preview-modal');
    const loading = document.getElementById('minipalm-preview-loading');
    const canvas = this.canvas;

    // Modal anzeigen
    modal.classList.add('active');
    loading.style.display = 'block';
    canvas.style.display = 'none';

    // Kurz warten für Modal-Animation
    await new Promise(resolve => setTimeout(resolve, 100));

    // Vorschau rendern
    await this.renderPreview();

    // Canvas anzeigen
    loading.style.display = 'none';
    canvas.style.display = 'block';
  },

  /**
   * Vorschau-Modal schließen
   */
  closePreview() {
    const modal = document.getElementById('minipalm-preview-modal');
    modal.classList.remove('active');
  },

  /**
   * Form-Daten auslesen
   */
  getFormData() {
    // Motiv aus Radio Buttons auslesen
    const motivRadio = document.querySelector('input[name="mp-motiv"]:checked');

    // Topffarbe aus Radio Buttons auslesen
    const topffarbeRadio = document.querySelector('input[name="mp-topffarbe"]:checked');

    return {
      name: document.getElementById('mp-name')?.value || '',
      topffarbe: topffarbeRadio?.value || 'Türkis',
      motiv: motivRadio?.value || ''
    };
  },

  /**
   * Warenkorb-Integration einrichten
   */
  setupCartIntegration() {
    // Hidden Fields ins Product Form einfügen
    const productForm = document.querySelector('form[action*="/cart/add"]');
    const hiddenFields = document.getElementById('mp-hidden-fields');

    if (productForm && hiddenFields) {
      // Hidden Fields ins Form verschieben
      productForm.appendChild(hiddenFields);
      console.log('MiniPalm: ✓ Hidden fields moved to product form');
    } else {
      console.warn('MiniPalm: ⚠ Product form or hidden fields not found');
    }

    // Bei Input-Änderungen automatisch synchronisieren
    const inputs = document.querySelectorAll('.mp-input');
    inputs.forEach(input => {
      input.addEventListener('change', () => this.syncFieldsToCart());
      input.addEventListener('blur', () => this.syncFieldsToCart());
    });

    // Bei Radio Button Änderungen synchronisieren
    const radioButtons = document.querySelectorAll('input[name="mp-motiv"], input[name="mp-topffarbe"]');
    radioButtons.forEach(radio => {
      radio.addEventListener('change', () => {
        this.syncFieldsToCart();
        // Bei Topffarbe-Änderung auch die Produktvariante synchronisieren
        if (radio.name === 'mp-topffarbe') {
          this.syncVariant(radio.value);
        }
      });
    });

    // Bei Form Submit synchronisieren
    if (productForm) {
      productForm.addEventListener('submit', () => {
        this.syncFieldsToCart();
      });
    }

    // Initiale Varianten-Synchronisation
    const initialTopffarbe = document.querySelector('input[name="mp-topffarbe"]:checked');
    if (initialTopffarbe) {
      this.syncVariant(initialTopffarbe.value);
    }

    console.log('MiniPalm: ✓ Cart integration setup complete');
  },

  /**
   * Produktvariante basierend auf Topffarbe synchronisieren
   */
  syncVariant(topffarbe) {
    // Suche nach dem Varianten-Selector im Theme
    // Versuche verschiedene Methoden, da Themes unterschiedlich aufgebaut sind

    // Methode 1: Klicke auf den entsprechenden Farb-Chip/Button im Theme
    const variantButtons = document.querySelectorAll('[data-option-value], .swatch-element, .variant-option, .color-swatch');
    variantButtons.forEach(btn => {
      const btnText = btn.textContent?.toLowerCase().trim() || '';
      const btnValue = btn.getAttribute('data-option-value')?.toLowerCase() || '';
      const btnTitle = btn.getAttribute('title')?.toLowerCase() || '';

      if (btnText.includes(topffarbe.toLowerCase()) ||
          btnValue.includes(topffarbe.toLowerCase()) ||
          btnTitle.includes(topffarbe.toLowerCase())) {
        btn.click();
        console.log('MiniPalm: ✓ Variant button clicked for:', topffarbe);
      }
    });

    // Methode 2: Ändere das Select-Dropdown falls vorhanden
    const variantSelects = document.querySelectorAll('select[name="options[Topffarbe]"], select.single-option-selector, select[data-option="Topffarbe"]');
    variantSelects.forEach(select => {
      Array.from(select.options).forEach(option => {
        if (option.text.toLowerCase().includes(topffarbe.toLowerCase()) ||
            option.value.toLowerCase().includes(topffarbe.toLowerCase())) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          console.log('MiniPalm: ✓ Variant select changed to:', topffarbe);
        }
      });
    });

    // Methode 3: Suche nach Radio-Buttons für Varianten
    const variantRadios = document.querySelectorAll('input[type="radio"][name*="option"], input[type="radio"][data-option-name="Topffarbe"]');
    variantRadios.forEach(radio => {
      if (radio.value.toLowerCase().includes(topffarbe.toLowerCase())) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        console.log('MiniPalm: ✓ Variant radio selected:', topffarbe);
      }
    });

    // Methode 4: Für Prestige Theme - suche nach chip inputs
    const chipInputs = document.querySelectorAll('.block-swatch-list input[type="radio"], .chip-list input[type="radio"]');
    chipInputs.forEach(input => {
      const label = input.nextElementSibling || document.querySelector(`label[for="${input.id}"]`);
      const labelText = label?.textContent?.toLowerCase().trim() || '';
      if (labelText.includes(topffarbe.toLowerCase()) || input.value.toLowerCase().includes(topffarbe.toLowerCase())) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        console.log('MiniPalm: ✓ Chip input selected for:', topffarbe);
      }
    });

    console.log('MiniPalm: Variant sync attempted for:', topffarbe);
  },

  /**
   * Felder mit Hidden Fields synchronisieren
   */
  syncFieldsToCart() {
    const formData = this.getFormData();

    // Werte in Hidden Fields kopieren
    const hiddenFields = {
      'mp-hidden-name': formData.name,
      'mp-hidden-topffarbe': formData.topffarbe,
      'mp-hidden-motiv': formData.motiv ? `Motiv ${formData.motiv}` : ''
    };

    Object.keys(hiddenFields).forEach(id => {
      const field = document.getElementById(id);
      if (field) {
        field.value = hiddenFields[id];
      }
    });

    console.log('MiniPalm: ✓ Fields synced to cart:', formData);
  },

  /**
   * Hauptfunktion: Vorschau rendern
   */
  async renderPreview() {
    if (this.isRendering) return;
    this.isRendering = true;

    try {
      const ctx = this.ctx;
      const canvas = this.canvas;

      // Canvas leeren
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Form-Daten holen
      const formData = this.getFormData();

      // 1. Base-Bild zeichnen (basierend auf Topffarbe)
      const baseImage = formData.topffarbe === 'Rosa' ? this.images.baseRosa : this.images.baseTuerkis;

      if (baseImage && baseImage.complete) {
        ctx.drawImage(baseImage, 0, 0, canvas.width, canvas.height);
      } else {
        // Fallback: Weißer Hintergrund
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        console.warn('MiniPalm: Base image not loaded, using white background');
      }

      // 2. Motiv laden und zeichnen (wenn ausgewählt)
      if (formData.motiv) {
        await this.loadMotiv(formData.motiv);
        this.drawMotiv(formData.topffarbe);
      }

      // 3. Name zeichnen (über dem Motiv)
      if (formData.name) {
        this.drawText('name', formData.name, formData.topffarbe);
      }

      console.log('MiniPalm: ✓ Preview rendered successfully');
    } catch (error) {
      console.error('MiniPalm: Error rendering preview:', error);
    } finally {
      this.isRendering = false;
    }
  },

  /**
   * Text zeichnen
   */
  drawText(fieldName, text, topffarbe = 'Türkis') {
    if (!text) return;

    const config = this.config.textConfig[fieldName];
    if (!config) return;

    const ctx = this.ctx;

    // Text auf 10 Zeichen begrenzen
    if (fieldName === 'name') {
      text = text.substring(0, 10);
    }

    // Position anpassen für Rosa
    let yPosition = config.y;
    let xPosition = config.x;
    if (fieldName === 'name' && topffarbe === 'Rosa') {
      yPosition += 30; // 30px nach unten für Rosa
      xPosition += 5; // 5px nach rechts für Rosa
    }

    // Font-Style setzen
    ctx.font = `${config.fontSize}px "${config.fontFamily}"`;
    ctx.fillStyle = config.color;
    ctx.textAlign = config.align;
    ctx.textBaseline = config.baseline;

    // Text-Schatten für bessere Lesbarkeit
    ctx.shadowColor = 'rgba(255, 255, 255, 0.5)';
    ctx.shadowBlur = 4;
    ctx.shadowOffsetX = 2;
    ctx.shadowOffsetY = 2;

    // Text zeichnen
    ctx.fillText(text, xPosition, yPosition);

    // Schatten zurücksetzen
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
  },

  /**
   * Motiv zeichnen
   */
  drawMotiv(topffarbe = 'Türkis') {
    if (!this.images.motiv) return;

    const config = this.config.motivConfig;
    const motiv = this.images.motiv;

    // Position anpassen für Rosa
    let yPosition = config.y;
    let xPosition = config.x;
    if (topffarbe === 'Rosa') {
      yPosition += 15; // 15px nach unten für Rosa (weniger als Text)
      xPosition += 5; // 5px nach rechts für Rosa
    }

    // Skalierung berechnen (aspect ratio beibehalten)
    let width = motiv.width;
    let height = motiv.height;

    const scale = Math.min(
      config.maxWidth / width,
      config.maxHeight / height,
      1 // Nicht größer als Original
    );

    width *= scale;
    height *= scale;

    // Zentriert zeichnen – mit hochwertiger Skalierung für saubere, durchgehende Linien
    const drawX = xPosition - width / 2;
    const drawY = yPosition - height / 2;
    this.ctx.imageSmoothingEnabled = true;
    this.ctx.imageSmoothingQuality = 'high';
    this.ctx.drawImage(motiv, drawX, drawY, width, height);
  }
};

// Auto-Initialisierung wenn DOM bereit
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => MiniPalmPreview.init());
} else {
  MiniPalmPreview.init();
}

// Für Debugging im Browser-Console
window.MiniPalmPreview = MiniPalmPreview;
